<template>
  <!-- eslint-disable max-len -->
  <svg
    width="60px"
    height="60px"
    viewBox="0 0 64 64"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Individual</title>
    <desc>An individual mover</desc>
    <defs>
      <polygon
        points="1.60353175e-15 0 64 0 64 64 1.60353175e-15 64"
      />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g>
        <mask
          fill="white"
        >
          <use xlink:href="#path-1" />
        </mask>
        <g />
        <path
          d="M52.752,47.2128 C50.2272,40.3648 45.4624,38.1088 41.6032,36.5088 C44.0256,33.1008 44.7392,27.712 44.7392,24.7968 C44.7392,17.7728 39.0272,12.0576 31.9968,12.0576 C24.9632,12.0576 19.2448,17.7728 19.2448,24.7968 L19.2512,24.7968 C19.2512,27.712 19.9648,33.1008 22.384,36.5088 C18.5344,38.1088 13.7664,40.3648 11.2384,47.2 C8.1088,42.9376 6.2528,37.6832 6.2528,31.9968 C6.2528,17.8048 17.8016,6.2464 32,6.2464 C46.1984,6.2464 57.7472,17.8048 57.7472,31.9968 C57.7472,37.6832 55.888,42.944 52.752,47.2128 M15.3984,51.6608 C16.9632,44.4224 20.8608,42.8 24.976,41.1136 C25.3888,40.9376 25.7984,40.768 26.1984,40.5984 L27.0592,40.2304 L27.7472,38.8992 L27.7472,34.4576 L27.3984,34.24 C25.9008,33.3408 24.4896,28.7584 24.4896,24.7968 C24.4896,20.6592 27.8528,17.2864 31.9968,17.2864 C36.1344,17.2864 39.504,20.6592 39.504,24.7968 C39.504,28.7584 38.0896,33.3408 36.5984,34.24 L36.1536,34.5024 L36.1536,38.7264 L36.9344,40.2304 L37.7984,40.6048 C38.1952,40.768 38.6048,40.9344 39.008,41.1136 C43.1296,42.8 47.0272,44.4224 48.5984,51.6704 C44.1088,55.4528 38.3168,57.7472 32,57.7472 C25.6768,57.7472 19.8848,55.4528 15.3984,51.6608 M32,0 C14.352,0 0,14.3488 0,31.9968 C0,49.6512 14.352,64 32,64 C49.6448,64 64,49.6512 64,31.9968 C64,14.3488 49.6448,0 32,0"
          fill="#999999"
          mask="url(#mask-2)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgIndividual',
};
</script>
